import React, { Fragment, useState, useContext, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { UrlServicesContext } from "../../components/UrlServicesContext";
import { Cancel } from "@material-ui/icons";
import FormControl from "@material-ui/core/FormControl";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Moment from "moment";

import imgLoader from "assets/img/progress.gif";
import successGif from "assets/img/success.gif";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#FAFAFA",
    },
  },
}))(TableRow);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function SearchStudent(props) {
  const classes = useStyles();

  const [mensaje, setMensaje] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [loader, setLoader] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [viewRow, setViewRow] = useState([]);
  const [view, setView] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    identificacion: "",
    errorIdentificacion: false,
  });

  useEffect(() => {
    userStudent();
  }, []);

  const userStudent = async () => {
    try {
      await axios
        .get(
          `${urlServices}routes_student.php?keyAplication=${keyAplication}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.code === 1) {
            setRows(response.data.data);
            setTimeout(() => {
              setLoader(false);
            }, 2000);
          } else if (response.data.code === 0) {
            setLoader(false);
            setDisabled(true);
            setMensaje("No hay datos registrados para consultar");
            setOpenAlert(true);
          } else {
            setLoader(false);
            setDisabled(true);
            setMensaje("Error de conexión");
            setOpenAlert(true);
          }
        })
        .catch((e) => {
          setLoader(false);
          setDisabled(true);
          setMensaje("Error de conexión");
          setOpenAlert(true);
          console.log(e);
        });
    } catch (error) {
      setLoader(false);
      setDisabled(true);
      setMensaje("Error de conexión");
      setOpenAlert(true);
      console.error(error);
      throw error;
    }
  };

  const submitForm = (e) => {
    e.preventDefault();

    if (values.identificacion.length === 0) {
      setValues({ ...values, errorIdentificacion: true });
      setMensaje("El campo es obligatorio.");
      setOpenAlert(true);
    } else {
      let datos = rows.filter(
        (filtered) => filtered.identificacion === values.identificacion
      );

      if (datos.length > 0) {
        setView(true);
        setViewRow(datos);
      } else {
        setMensaje("Estudiante no registrado en nuestra base de datos.");
        setOpenAlert(true);
      }
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorIdentificacion: false,
    });
    setView(false);
    setViewRow([]);
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.titleCardFilter}>
                      Nueva busqueda de estudiante
                    </div>
                    <div className={classes.lineBottom}></div>
                    <br></br>
                  </Grid>
                </Grid>
                {loader ? (
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          src={imgLoader}
                          alt="loader"
                          style={{
                            width: 50,
                            margin: "20px 0",
                            objectFit: "contain",
                          }}
                        />
                        <br></br>
                        <b>CARGANDO DATOS ...</b>
                      </center>
                    </Grid>
                  </Grid>
                ) : (
                  <form onSubmit={submitForm}>
                    <Grid container spacing={1}>
                      {openAlert ? (
                        <Grid item xs={12} sm={12}>
                          <Alert variant="filled" severity="error">
                            {mensaje}
                          </Alert>
                        </Grid>
                      ) : null}
                      <Grid item xs={12} sm={3}>
                        {" "}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl style={{ width: "100%" }}>
                          <TextField
                            name="name"
                            value={values.identificacion}
                            error={values.errorIdentificacion}
                            onChange={handleChange("identificacion")}
                            fullWidth
                            required
                            label="Ingrese la identificación"
                            autoComplete="off"
                            variant="outlined"
                            placeholder="1726104238"
                            type="number"
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        {" "}
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <br></br>
                        <center>
                          <Button
                            type="submit"
                            className={classes.buttonSubmit}
                            onClick={submitForm}
                            disabled={disabled}
                          >
                            Buscar
                          </Button>
                        </center>
                      </Grid>
                    </Grid>
                  </form>
                )}
                <Grid item xs={12} md={12}>
                  {view ? (
                    <>
                      <center>
                        <img
                          src={successGif}
                          alt="successGif"
                          style={{
                            width: 80,
                            margin: "40px 0px 5px 0px",
                            objectFit: "contain",
                          }}
                        />
                      </center>
                      <TableContainer>
                        <Table
                          className={classes.table}
                          size="small"
                          aria-label="a dense table"
                        >
                          <TableBody>
                            {viewRow.map((row, key) => (
                              <>
                                <StyledTableRow key={key}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    colSpan={2}
                                  >
                                    Nombres:<br></br> <b>{row.nombres}</b>
                                  </TableCell>
                                  {/*<TableCell>
                                    Apellidos:<br></br> <b>{row.apellidos}</b>
                                  </TableCell>*/}
                                </StyledTableRow>
                                <StyledTableRow key={key}>
                                  <TableCell component="th" scope="row">
                                    Identificación:<br></br>{" "}
                                    <b>{row.identificacion}</b>
                                  </TableCell>
                                  <TableCell>
                                    Género:<br></br> <b>{row.gendername}</b>
                                  </TableCell>
                                </StyledTableRow>
                                <StyledTableRow key={key}>
                                  <TableCell component="th" scope="row">
                                    fecha de nacimiento:<br></br>
                                    <b>
                                      {Moment(row.fecha_nacimiento).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </b>
                                  </TableCell>
                                  <TableCell>
                                    Celular:<br></br> <b>{row.celular}</b>
                                  </TableCell>
                                </StyledTableRow>
                                <StyledTableRow key={key}>
                                  <TableCell component="th" scope="row">
                                    Teléfono:<br></br> <b>{row.telefono}</b>
                                  </TableCell>
                                  <TableCell>
                                    Correo personal:<br></br>
                                    <b>{row.correo_personal}</b>
                                  </TableCell>
                                </StyledTableRow>
                                <StyledTableRow key={key}>
                                  <TableCell component="th" scope="row">
                                    Correo institucional:<br></br>{" "}
                                    <b>{row.correo_institucional}</b>
                                  </TableCell>
                                  <TableCell>
                                    Fecha de emisión:<br></br>{" "}
                                    <b>
                                      {Moment(row.fecha_emision).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </b>
                                  </TableCell>
                                </StyledTableRow>
                                <StyledTableRow key={key}>
                                  <TableCell component="th" scope="row">
                                    Tipo estudios:<br></br>{" "}
                                    <b>{row.tipo_estudios}</b>
                                  </TableCell>
                                  <TableCell>
                                    Inicio clases:<br></br>{" "}
                                    <b>
                                      {Moment(row.inicio_clases).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </b>
                                  </TableCell>
                                </StyledTableRow>
                                <StyledTableRow key={key}>
                                  <TableCell component="th" scope="row">
                                    Programa académico:<br></br>{" "}
                                    <b>{row.programa_academico}</b>
                                  </TableCell>
                                </StyledTableRow>
                              </>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
